// apps/web/src/features/clients/components/EditorCancelButton.tsx
//
// WHY: Cancel is an in-form close affordance, not a Modal-chrome close path
// (X / Esc / backdrop) — those are handled by EditorModal internally. Routing
// Cancel through `confirmDestructive` keeps a dirty form from discarding typed
// input silently. Shared by the client workspace editors so all of them prompt
// identically.
import type { CSSProperties } from 'react';
import { Button, useEditorGuard } from '../../../ui/index.js';

export function EditorCancelButton({
  onClose,
  label,
  style,
}: {
  onClose: () => void;
  label: string;
  /** Touch sizing from the calling editor; empty on desktop. */
  style: CSSProperties;
}) {
  const { confirmDestructive } = useEditorGuard();
  return (
    <Button kind="ghost" style={style} onClick={() => confirmDestructive(onClose)}>
      {label}
    </Button>
  );
}
